import {sortBy} from "lodash"
import {paramById, getItemById} from 'help@/store'

// getters
const getters = {
    getErrorById: state => id => getItemById(state.errors, id),

    checkErrors: state => !!state.errors.length,

    isFieldRequired: state => id => state.requiredFields.includes(id),

    getSortedGroups: state => sortBy(state.groups, ['id']),

    isGroupsExist: state => state.groups.length > 0,

    getValueOf: state => id =>
        (state.formData.hasOwnProperty(id)) ?
            state.formData[id]
            : undefined,

    isExist: (state, getters) => id => {
        let value = getters.getValueOf(id)
        if (typeof value === 'object') {
            value = value.value
        }
        return (value && value !== 'false') ? value.toString().trim().length > 0 : false
    },

    isHidden: state => id => {
        let param = paramById(state.groups, id)
        return !!(param.hidden)
    },
}

export default getters
